import React from "react";
import { Alert } from "react-bootstrap";

export default function MissingVariablesAlert({ missingVariables = [] }) {
  if (!missingVariables.length) {
    return null;
  }

  return (
    <Alert variant="warning" className="missing-variables-alert mx-3 mt-3">
      <Alert.Heading as="h2" className="h5 mb-2">
        Variables manquantes dans le rapport
      </Alert.Heading>
      <p className="mb-2">
        Certaines variables du gabarit n&apos;ont pas pu être remplies. Les
        emplacements concernés sont marqués{" "}
        <span className="pcrs-missing-variable">[???]</span> dans le texte
        ci-dessous.
      </p>
      <ul className="mb-0 ps-3">
        {missingVariables.map((label) => (
          <li key={label}>{label}</li>
        ))}
      </ul>
    </Alert>
  );
}
